import { TipoPermissao } from "constants/EnumTipoPermissao";
import { TipoSituacaoProcessoJudicial } from "constants/EnumTipoSituacaoProcessoJudicial";
import { usePermissoesContext } from "context/permissoes/PermissoesContext";
import { createContext, useContext, useState } from "react";
import { OpcoesSelecionaveisCheckBox } from "types/OpcoesSelecionaveisCheckBoxType";
import { AnexoType } from "types/anexo/AnexoType";
import { Page } from "types/dto/Page";
import { RegistroContaReceberDTO } from "types/dto/RegistroContaReceberDTO";
import { FiltrosTabela } from "types/table/FiltrosTabela";

export type ProcessosJudiciaisProps = {
  showModalProcessosJudiciais: boolean;
  openCloseModalProcessosJudiciais: () => void;
  showModalAdicionarProcessoJudicialHistorico: boolean;
  openCloseModalAdicionarProcessoJudicialHistorico: () => void;
  showModalVisualizarProcessoJudicialHistorico: boolean;
  openCloseModalVisualizarProcessoJudicialHistorico: () => void;
  unidadeSacadoQuery: string | null;
  setUnidadeSacadoQuery: (unidadeSacadoQuery: string) => void;
  tipoSituacaoProcessoJudicial: TipoSituacaoProcessoJudicial | null;
  setTipoSituacaoProcessoJudicial: (tipoSituacaoProcessoJudicial: TipoSituacaoProcessoJudicial) => void;
  condominioId: number | null | undefined;
  setCondominioId: (condominioId: number | null) => void;
  unidadeId: number | null | undefined;
  setUnidadeId: (unidadeId: number | null) => void;
  numeroProcesso: string | null | undefined;
  setNumeroProcesso: (numeroProcesso: string | null) => void;
  possuiAcordosVinculados: boolean;
  setPossuiAcordosVinculados: () => void;
  acordos: (number | undefined)[] | undefined;
  setAcordos: () => void;
  isVisualizacao: boolean;
  isEdicao: boolean;
  setIsVisualizacao: (isVisualizacao: boolean) => void;
  setIsEdicao: (isVisualizacao: boolean) => void;
  anexos: AnexoType[];
  setAnexos: (anexos: AnexoType[]) => void;
  possuiPermissaoVisualizarProcessosJudiciais: boolean;
  possuiPermissaoEditarProcessosJudiciais: boolean;
  possuiPermissaoIncluirProcessosJudiciais: boolean;
  possuiPermissaoExcluirProcessosJudiciais: boolean;
  possuiPermissaoExecutarProcessosJudiciais: boolean;
  possuiAcessoTelaProcessosJudiciais: boolean;
  showModalSelecionarCobrancas: boolean;
  openCloseModalSelecionarCobrancas: () => void;
  filtroTabelaSelecionarCobranca: FiltrosTabela;
  setFiltroTabelaSelecionarCobranca: (filtroTabelaSelecionarCobranca: FiltrosTabela) => void;
  registrosTabelaModalSelecionarCobrancas: Page<RegistroContaReceberDTO> | undefined;
  setRegistrosTabelaModalSelecionarCobrancas: (
    registrosTabelaModalSelecionarCobrancas: Page<RegistroContaReceberDTO>
  ) => void;
  cobrancasModalSelecionadas: RegistroContaReceberDTO[];
  setCobrancasModalSelecionadas: (cobrancasModalSelecionadas: RegistroContaReceberDTO[]) => void;
  idsCobrancasModalSelecionadas: number[];
  setIdsCobrancasModalSelecionadas: (idsCobrancasModalSelecionadas: number[]) => void;
  opcaoCheckBoxSelecionarCobrancasModal: OpcoesSelecionaveisCheckBox;
  setOpcaoCheckBoxSelecionarCobrancasModal: (
    opcaoCheckBoxSelecionarCobrancasModal: OpcoesSelecionaveisCheckBox
  ) => void;
  idsCobrancasVinculadasAoProcessoSelecionadas: number[];
  setIdsCobrancasVinculadasAoProcessoSelecionadas: (idsCobrancasVinculadasAoProcessoSelecionadas: number[]) => void;
  opcaoCheckBoxSelecionarCobrancasVinculadasAoProcesso: OpcoesSelecionaveisCheckBox;
  setOpcaoCheckBoxSelecionarCobrancasVinculadasAoProcesso: (
    opcaoCheckBoxSelecionarCobrancasVinculadasAoProcesso: OpcoesSelecionaveisCheckBox
  ) => void;
  processoPossuiCobrancasVinculadas: boolean;
  setProcessoPossuiCobrancasVinculadas: (processoPossuiCobrancasVinculadas: boolean) => void;
  possuiPermissaoIniciarAcordo: boolean;
  possuiPermissaoVisualizarDetalhesProcesso: boolean;
};

const INITIAL_CONTEXT = {
  showModalProcessosJudiciais: false,
  openCloseModalProcessosJudiciais: () => {},
  showModalAdicionarProcessoJudicialHistorico: false,
  openCloseModalAdicionarProcessoJudicialHistorico: () => {},
  showModalVisualizarProcessoJudicialHistorico: false,
  openCloseModalVisualizarProcessoJudicialHistorico: () => {},
  tipoSituacaoProcessoJudicial: null,
  setTipoSituacaoProcessoJudicial: () => {},
  unidadeSacadoQuery: null,
  setUnidadeSacadoQuery: () => {},
  condominioId: null,
  setCondominioId: () => {},
  unidadeId: null,
  setUnidadeId: () => {},
  numeroProcesso: null,
  setNumeroProcesso: () => {},
  possuiAcordosVinculados: false,
  setPossuiAcordosVinculados: () => {},
  acordos: [],
  setAcordos: () => {},
  isVisualizacao: false,
  setIsVisualizacao: () => {},
  isEdicao: false,
  setIsEdicao: () => {},
  anexos: [],
  setAnexos: () => {},
  possuiPermissaoVisualizarProcessosJudiciais: false,
  possuiPermissaoEditarProcessosJudiciais: false,
  possuiPermissaoIncluirProcessosJudiciais: false,
  possuiPermissaoExcluirProcessosJudiciais: false,
  possuiPermissaoExecutarProcessosJudiciais: false,
  possuiAcessoTelaProcessosJudiciais: false,
  showModalSelecionarCobrancas: false,
  openCloseModalSelecionarCobrancas: () => {},
  filtroTabelaSelecionarCobranca: {
    ordenacaoAscOuDesc: undefined,
    ordenarPorColuna: "",
    paginaAtual: 1,
    sortString: "",
  },
  setFiltroTabelaSelecionarCobranca: () => {},
  registrosTabelaModalSelecionarCobrancas: {} as Page<RegistroContaReceberDTO>,
  setRegistrosTabelaModalSelecionarCobrancas: () => {},
  cobrancasModalSelecionadas: [],
  setCobrancasModalSelecionadas: () => {},
  idsCobrancasModalSelecionadas: [],
  setIdsCobrancasModalSelecionadas: () => {},
  opcaoCheckBoxSelecionarCobrancasModal: "NENHUMA" as OpcoesSelecionaveisCheckBox,
  setOpcaoCheckBoxSelecionarCobrancasModal: () => {},
  idsCobrancasVinculadasAoProcessoSelecionadas: [],
  setIdsCobrancasVinculadasAoProcessoSelecionadas: () => {},
  opcaoCheckBoxSelecionarCobrancasVinculadasAoProcesso: "NENHUMA" as OpcoesSelecionaveisCheckBox,
  setOpcaoCheckBoxSelecionarCobrancasVinculadasAoProcesso: () => {},
  processoPossuiCobrancasVinculadas: false,
  setProcessoPossuiCobrancasVinculadas: () => {},
  possuiPermissaoIniciarAcordo: false,
  possuiPermissaoVisualizarDetalhesProcesso: false,
};

export const ProcessosJudiciais = createContext<ProcessosJudiciaisProps>(INITIAL_CONTEXT);

export const ProcessosJudiciaisProvider = ({ children }: any) => {
  const [showModalProcessosJudiciais, setShowModalProcessosJudiciais] = useState<boolean>(false);
  const [showModalAdicionarProcessoJudicialHistorico, setShowModalAdicionarProcessoJudicialHistorico] =
    useState<boolean>(false);
  const [showModalVisualizarProcessoJudicialHistorico, setShowModalVisualizarProcessoJudicialHistorico] =
    useState<boolean>(false);
  const [condominioId, setCondominioId] = useState<number | null>(null);
  const [unidadeId, setUnidadeId] = useState<number | null>(null);
  const [numeroProcesso, setNumeroProcesso] = useState<string | null>(null);
  const [possuiAcordosVinculados, setPossuiAcordosVinculados] = useState<boolean>(false);
  const [acordos] = useState();
  const [unidadeSacadoQuery, setUnidadeSacadoQuery] = useState<string | null>(null);
  const [tipoSituacaoProcessoJudicial, setTipoSituacaoProcessoJudicial] = useState<TipoSituacaoProcessoJudicial | null>(
    null
  );
  const [isVisualizacao, setIsVisualizacao] = useState<boolean>(false);
  const [isEdicao, setIsEdicao] = useState<boolean>(false);
  const [anexos, setAnexos] = useState<AnexoType[]>([]);
  const [showModalSelecionarCobrancas, setShowModalAdicionarCobrancas] = useState<boolean>(false);
  const [registrosTabelaModalSelecionarCobrancas, setRegistrosTabelaModalSelecionarCobrancas] =
    useState<Page<RegistroContaReceberDTO>>();
  const [filtroTabelaSelecionarCobranca, setFiltroTabelaSelecionarCobranca] = useState<FiltrosTabela>({
    ordenacaoAscOuDesc: undefined,
    ordenarPorColuna: "",
    paginaAtual: 1,
    sortString: "",
  });
  const [cobrancasModalSelecionadas, setCobrancasModalSelecionadas] = useState<RegistroContaReceberDTO[]>([]);
  const [idsCobrancasModalSelecionadas, setIdsCobrancasModalSelecionadas] = useState<number[]>([]);
  const [opcaoCheckBoxSelecionarCobrancasModal, setOpcaoCheckBoxSelecionarCobrancasModal] =
    useState<OpcoesSelecionaveisCheckBox>("NENHUMA");

  const [idsCobrancasVinculadasAoProcessoSelecionadas, setIdsCobrancasVinculadasAoProcessoSelecionadas] = useState<
    number[]
  >([]);
  const [
    opcaoCheckBoxSelecionarCobrancasVinculadasAoProcesso,
    setOpcaoCheckBoxSelecionarCobrancasVinculadasAoProcesso,
  ] = useState<OpcoesSelecionaveisCheckBox>("NENHUMA");

  const [processoPossuiCobrancasVinculadas, setProcessoPossuiCobrancasVinculadas] = useState<boolean>(false);

  const { usuarioPossuiPermissao } = usePermissoesContext();

  const openCloseModalProcessosJudiciais = () => {
    setShowModalProcessosJudiciais(!showModalProcessosJudiciais);
  };

  const openCloseModalAdicionarProcessoJudicialHistorico = () => {
    setShowModalAdicionarProcessoJudicialHistorico(!showModalAdicionarProcessoJudicialHistorico);
  };

  const openCloseModalVisualizarProcessoJudicialHistorico = () => {
    setShowModalVisualizarProcessoJudicialHistorico(!showModalVisualizarProcessoJudicialHistorico);
  };

  const changeCondominioId = (condominioId: number | null) => {
    setCondominioId(condominioId);
  };

  const changeUnidadeId = (unidadeId: number | null) => {
    setUnidadeId(unidadeId);
  };

  const changeNumeroProcesso = (numeroProcesso: string | null) => {
    setNumeroProcesso(numeroProcesso);
  };

  const changePossuiAcordosVinculados = () => {
    setPossuiAcordosVinculados(!possuiAcordosVinculados);
  };

  const changeUnidadeSacadoQuery = (unidadeSacadoQuery: string) => {
    setUnidadeSacadoQuery(unidadeSacadoQuery);
  };

  const changeTipoSituacaoProcessoJudicial = (situacao: TipoSituacaoProcessoJudicial) => {
    setTipoSituacaoProcessoJudicial(situacao);
  };

  const possuiAcessoTelaProcessosJudiciais = (): boolean => {
    return (
      usuarioPossuiPermissao("processos", TipoPermissao.VISUALIZAR) ||
      usuarioPossuiPermissao("processos", TipoPermissao.ALTERAR) ||
      usuarioPossuiPermissao("processos", TipoPermissao.INCLUIR) ||
      usuarioPossuiPermissao("processos", TipoPermissao.EXCLUIR) ||
      usuarioPossuiPermissao("processos", TipoPermissao.EXECUTAR)
    );
  };

  const changeAcordos = () => {};

  const changeIsVisualizacao = (isVisualizacao: boolean) => {
    setIsVisualizacao(isVisualizacao);
  };

  const changeIsEdicao = (isEdicao: boolean) => {
    setIsEdicao(isEdicao);
  };

  const changeAnexos = (anexos: AnexoType[]) => {
    setAnexos(anexos);
  };

  const openCloseModalSelecionarCobrancas = () => {
    setShowModalAdicionarCobrancas(!showModalSelecionarCobrancas);
  };

  const contextData: ProcessosJudiciaisProps = {
    showModalProcessosJudiciais,
    openCloseModalProcessosJudiciais,
    showModalAdicionarProcessoJudicialHistorico,
    openCloseModalAdicionarProcessoJudicialHistorico,
    showModalVisualizarProcessoJudicialHistorico,
    openCloseModalVisualizarProcessoJudicialHistorico,
    condominioId,
    setCondominioId: changeCondominioId,
    unidadeId,
    setUnidadeId: changeUnidadeId,
    numeroProcesso,
    setNumeroProcesso: changeNumeroProcesso,
    possuiAcordosVinculados,
    setPossuiAcordosVinculados: changePossuiAcordosVinculados,
    acordos,
    setAcordos: changeAcordos,
    unidadeSacadoQuery,
    setUnidadeSacadoQuery: changeUnidadeSacadoQuery,
    tipoSituacaoProcessoJudicial,
    setTipoSituacaoProcessoJudicial: changeTipoSituacaoProcessoJudicial,
    isVisualizacao,
    isEdicao,
    setIsVisualizacao: changeIsVisualizacao,
    setIsEdicao: changeIsEdicao,
    anexos,
    setAnexos: changeAnexos,
    possuiPermissaoVisualizarProcessosJudiciais: usuarioPossuiPermissao("processos", TipoPermissao.VISUALIZAR),
    possuiPermissaoEditarProcessosJudiciais: usuarioPossuiPermissao("processos", TipoPermissao.ALTERAR),
    possuiPermissaoIncluirProcessosJudiciais: usuarioPossuiPermissao("processos", TipoPermissao.INCLUIR),
    possuiPermissaoExcluirProcessosJudiciais: usuarioPossuiPermissao("processos", TipoPermissao.EXCLUIR),
    possuiPermissaoExecutarProcessosJudiciais: usuarioPossuiPermissao("processos", TipoPermissao.EXECUTAR),
    possuiAcessoTelaProcessosJudiciais: possuiAcessoTelaProcessosJudiciais(),
    possuiPermissaoIniciarAcordo: usuarioPossuiPermissao("iniciarAcordoGestaoCobranca", TipoPermissao.EXECUTAR),
    possuiPermissaoVisualizarDetalhesProcesso: usuarioPossuiPermissao(
      "visualizarDetalhesProcesso",
      TipoPermissao.EXECUTAR
    ),
    showModalSelecionarCobrancas,
    openCloseModalSelecionarCobrancas,
    filtroTabelaSelecionarCobranca,
    setFiltroTabelaSelecionarCobranca,
    registrosTabelaModalSelecionarCobrancas,
    setRegistrosTabelaModalSelecionarCobrancas,
    cobrancasModalSelecionadas,
    setCobrancasModalSelecionadas,
    idsCobrancasModalSelecionadas,
    setIdsCobrancasModalSelecionadas,
    opcaoCheckBoxSelecionarCobrancasModal,
    setOpcaoCheckBoxSelecionarCobrancasModal,
    idsCobrancasVinculadasAoProcessoSelecionadas,
    setIdsCobrancasVinculadasAoProcessoSelecionadas,
    opcaoCheckBoxSelecionarCobrancasVinculadasAoProcesso,
    setOpcaoCheckBoxSelecionarCobrancasVinculadasAoProcesso,
    processoPossuiCobrancasVinculadas,
    setProcessoPossuiCobrancasVinculadas,
  };

  return <ProcessosJudiciais.Provider value={contextData}>{children}</ProcessosJudiciais.Provider>;
};

export function useProcessosJudiciaisContext() {
  return useContext(ProcessosJudiciais);
}
